export default __webpack_public_path__ + "static/media/ladies_lagging.318a682e.png";